import firebase from "firebase";

const config = {
  apiKey: "AIzaSyD4SWX-3IvKd48cE1dIlY2ZWseOnl1nGaQ",
  authDomain: "district-track-club.firebaseapp.com",
  databaseURL: "https://district-track-club.firebaseio.com/",
};
firebase.initializeApp(config);

export default firebase;
